export default "__VITE_ASSET___geREs01__"